import { IMAGE_UPLOAD_MAX_SIZE_KB } from '@/shared/constants';
import { routes } from '@/shared/routes';

import { alertModal } from '@/front/modal';

document.addEventListener('DOMContentLoaded', function () {
  initPortalLogoFileValidation();
  initEnvelopePriceSelect();
});

const initPortalLogoFileValidation = () => {
  const portalLogoInput = document.querySelector<HTMLInputElement>('input[name="portalLogoFile"]');

  if (!portalLogoInput) return;

  portalLogoInput.addEventListener('change', () => {
    const file = portalLogoInput.files?.[0];

    if (file && file.size > IMAGE_UPLOAD_MAX_SIZE_KB * 1024) {
      const message = `File is too large. Max size is ${IMAGE_UPLOAD_MAX_SIZE_KB}KB.`;
      portalLogoInput.setCustomValidity(message);
      alertModal(message);
      portalLogoInput.reportValidity();
      portalLogoInput.value = '';
      return;
    }

    portalLogoInput.setCustomValidity('');
  });
};

const initEnvelopePriceSelect = () => {
  const envelopePriceSelect = document.getElementById('envelopePriceSelect') as HTMLSelectElement | null;

  if (!envelopePriceSelect) return;

  envelopePriceSelect.addEventListener('change', () => {
    const quantity = envelopePriceSelect.value;

    if (quantity) {
      (window.parent || window).location.href = routes.account.purchase.envelopes({ quantity });
    }
  });
};
